// extracted by mini-css-extract-plugin
export default {"formWrap":"user_formWrap__R-x9X"};